<template>
  <form>
    <v-row>
      <v-col
        cols="12"
        class="pb-0"
      >
        <v-autocomplete
          v-model="workday"
          v-validate="'required'"
          label="New Workdays"
          :items="workSessionTypes"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          :error-messages="errors.collect('workday_id')"
          data-vv-name="workday_id"
          data-vv-as="workday"
        />
      </v-col>
    </v-row>
 
    <v-row v-show="workday">
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Monday Session"
          disabled
          :value="formSession.monSession"
        />
      </v-col>
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-autocomplete
          v-model="formSession.monLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
    
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Tuesday Session"
          disabled
          :value="formSession.tueSession"
        />
      </v-col>

      <v-col
        cols="3"
        class="py-0" 
      >
        <v-autocomplete
          v-model="formSession.tueLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
    
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Wednesday Session"
          disabled
          :value="formSession.wedSession"
        />
      </v-col>

      <v-col
        cols="3" 
        class="py-0"
      >
        <v-autocomplete
          v-model="formSession.wedLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
     
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Thursday Session"
          disabled
          :value="formSession.thuSession"
        />
      </v-col>

      <v-col
        cols="3" 
        class="py-0"
      >
        <v-autocomplete
          v-model="formSession.thuLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
      
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Friday Session"
          disabled
          :value="formSession.friSession"
        />
      </v-col>

      <v-col
        cols="3" 
        class="py-0"
      >
        <v-autocomplete
          v-model="formSession.friLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
 
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Saturday Session"
          disabled
          :value="formSession.satSession"
        />
      </v-col>

      <v-col
        cols="3" 
        class="py-0"
      >
        <v-autocomplete
          v-model="formSession.satLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
    
      <v-col
        cols="3" 
        class="py-0"
      >
        <v-text-field
          label="Sunday Session"
          disabled
          :value="formSession.sunSession"
        />
      </v-col>

      <v-col
        cols="3" 
        class="py-0"
      >
        <v-autocomplete
          v-model="formSession.sunLeaveSession"
          :items="leaveSessions"
          label="Leave Session"
          item-text="name"
          item-value="id"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-row class="text-right">
      <v-col cols="12">
        <v-btn 
          text
          class="px-10"  
          :disabled="progressing"
          @click="goPrevious"
        >
          Go back
        </v-btn>
        <v-btn
          color="hrissecondary"
          :loading="progressing"
          class="white--text px-10"
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
  export default {
    components: {
    },
    $_veeValidate: {
      validator: 'new', // give me my own validator scope.
    },
   
    data () {
      return {
        progressing: false,
        workday: null,
        workSessionTypes: [],
        leaveSessions: [],
        formSession: {
          monSession: '',
          tueSession: '',
          wedSession: '',
          thuSession: '',
          friSession: '',
          satSession: '',
          sunSession: '',

          monLeaveSession: 1,
          tueLeaveSession: 1,
          wedLeaveSession: 1,
          thuLeaveSession: 1,
          friLeaveSession: 1,
          satLeaveSession: 4,
          sunLeaveSession: 1,
        },
      }
    },
   
    computed: {
      selectedWorkSessionType () {
        if (!this.workday) return
        return this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.workday })
      },
    },
    mounted () {
      this.loadData()
    },

    methods: {
      loadData () {
        Promise.all([
          this.$api.workSessionTypes().list(),
          this.$api.hrisLeaveSessions().list(),
        ]).then(([workdays, leaveSession]) => {
          this.workSessionTypes = _.orderBy(workdays.data, ['name'], ['asc'])
          this.leaveSessions = _.orderBy(leaveSession.data, ['name'], ['asc'])
        
          leaveSession.data.forEach(item => {
            if (item.name === 'None') {
              item.name = 'No Restriction'
            } else if (item.name === 'A.M') {
              item.name = 'A.M only'
            } else if (item.name === 'P.M') {
              item.name = 'P.M only'
            } else {
              item.name = 'Full Day'
            }
          })
        })
      },

      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 
          this.$emit('submit-form')
        })
      },
      goPrevious () {
        this.$emit('previous-step')
      },

      getFormData () {
        return [
          {
            day: 1,
            work_session_id: this.selectedWorkSessionType.work_sessions[0].id,
            leave_session_id: this.selectedWorkSessionType.monLeaveSession,
            is_payroll_fullday: 0,
          },
          {
            day: 2,
            work_session_id: this.selectedWorkSessionType.work_sessions[1].id,
            leave_session_id: this.selectedWorkSessionType.tueLeaveSession,
            is_payroll_fullday: 0,
          },
          {
            day: 3,
            work_session_id: this.selectedWorkSessionType.work_sessions[2].id,
            leave_session_id: this.selectedWorkSessionType.wedLeaveSession,
            is_payroll_fullday: 0,
          },
          {
            day: 4,
            work_session_id: this.selectedWorkSessionType.work_sessions[3].id,
            leave_session_id: this.selectedWorkSessionType.thuLeaveSession,
            is_payroll_fullday: 0,
          },
          {
            day: 5,
            work_session_id: this.selectedWorkSessionType.work_sessions[4].id,
            leave_session_id: this.selectedWorkSessionType.friLeaveSession,
            is_payroll_fullday: 0,
          },
          {
            day: 6,
            work_session_id: this.selectedWorkSessionType.work_sessions[5].id,
            leave_session_id: this.selectedWorkSessionType.satLeaveSession,
            is_payroll_fullday: 0,
          },
          {
            day: 7,
            work_session_id: this.selectedWorkSessionType.work_sessions[6].id,
            leave_session_id: this.selectedWorkSessionType.sunLeaveSession,
            is_payroll_fullday: 0,
          },
        ]
      },

      loadingTrue () {
        this.progressing = true
      },

      loadingFalse () {
        this.progressing = false
      },
    },
  }
</script>
